import { render, staticRenderFns } from "./AppAccessRestrictedPage.vue?vue&type=template&id=0db253b4&"
import script from "./AppAccessRestrictedPage.vue?vue&type=script&lang=js&"
export * from "./AppAccessRestrictedPage.vue?vue&type=script&lang=js&"
import style0 from "./AppAccessRestrictedPage.vue?vue&type=style&index=0&id=0db253b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports